import firebase from 'firebase';

// Initialize Firebase
const config = {
  apiKey: 'AIzaSyB_7qfFdAhWZjdk3kcWESSjCqrl6cuM_ig',
  authDomain: 'real-time-chat-a5214.firebaseapp.com',
  databaseURL: 'https://real-time-chat-a5214.firebaseio.com',
  projectId: 'real-time-chat-a5214',
  storageBucket: 'real-time-chat-a5214.appspot.com',
  messagingSenderId: '952770956699',
};
firebase.initializeApp(config);

export default firebase;
